import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await fetch('https://formspree.io/f/xvgzzjzj', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setStatus('Thank you for reaching out! I will get back to you in a few hours.');
      setFormData({ name: '', email: '', message: '' }); // Reset form fields
    } else {
      setStatus('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="contact-container">
      {/* Left Section: Contact Info */}
      <div className="contact-info">
        <h1>Let's Connect!</h1>
        <p>
          I appreciate you reaching out! Whether you have a question, feedback, or a potential collaboration in mind, 
          I'd love to hear from you. Feel free to contact me through the form.
        </p>

        {/* Download Resume Button */}
        <a href="/Arya_Resume.pdf" download className="download-resume">
          Download Resume
        </a>
      </div>

      {/* Right Section: Contact Form */}
      <div className="contact-form">
        <h2>Send a Message</h2>
        {status && <p className="form-status">{status}</p>}
        <form onSubmit={handleSubmit}>
          <input type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} required />
          <input type="email" name="email" placeholder="Your Email" value={formData.email} onChange={handleChange} required />
          <textarea name="message" placeholder="Your Message" value={formData.message} onChange={handleChange} required />
          <button type="submit">Send</button>
        </form>
      </div>
    </div>
  );
}

export default Contact;
